import { render, staticRenderFns } from "./UIProfilePost.vue?vue&type=template&id=3e5157ab"
import script from "./UIProfilePost.vue?vue&type=script&lang=js"
export * from "./UIProfilePost.vue?vue&type=script&lang=js"
import style0 from "./UIProfilePost.vue?vue&type=style&index=0&id=3e5157ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TruncateParagraph: require('/skade-pwa/components/ui/atom/TruncateParagraph.vue').default,PortfolioCardWithDonutChartSkeleton: require('/skade-pwa/components/ui/atom/skeleton/PortfolioCardWithDonutChartSkeleton.vue').default,Card: require('/skade-pwa/components/ui/atom/Card.vue').default})
